/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Pack_NameInputs */

const en_features_pack_name = /** @type {(inputs: Features_Pack_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10-session pack`)
};

const pl_features_pack_name = /** @type {(inputs: Features_Pack_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakiet 10 treningów`)
};

/**
* | output |
* | --- |
* | "10-session pack" |
*
* @param {Features_Pack_NameInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_pack_name = /** @type {((inputs?: Features_Pack_NameInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Pack_NameInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_pack_name(inputs)
	return en_features_pack_name(inputs)
});